import { render, staticRenderFns } from "./historys.vue?vue&type=template&id=a8d31754&scoped=true"
import script from "./historys.vue?vue&type=script&lang=js"
export * from "./historys.vue?vue&type=script&lang=js"
import style0 from "./historys.vue?vue&type=style&index=0&id=a8d31754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d31754",
  null
  
)

export default component.exports